import './StatusBadge.css';

export const StatusBadge = ({ label, variant = 'neutral' }) => (
    <span className={`status-badge status-badge-${variant}`}>{label}</span>
);
